import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Introduction from "../components/introduction"
import TextBanner from "../components/textBanner"
import Seo from "../components/seo"
import ContactInformation from "../components/contactInformation"
import FormWrapper from "../components/formWrapper"
import Office from "../components/office"
import { graphql } from "gatsby"

const ContactPage = ({data}) => {

  const seoInfo = data.datoCmsContactPage
  return(
  <Layout page="Contact">
    <Seo title={seoInfo.metaTitle} description={seoInfo.metaDescription} />

    <Introduction title="Contact Us" />

    <div className="grid grid-2 max-1000 ma pt40 bt1-dark m-b0 gutter-1000">
      <Office
        name="Brisbane Office"
        email="admin@lewisandtrovas.com"
        phone="+61 7 3333 2858"
        address="Level 7, 10 Market Street, Brisbane CBD 4000"
        mail="GPO Box 3222, Brisbane CBD QLD 4001"
        lat={-27.4697265}
        lng={153.0297097}
      />
      <Office
        name="Sydney Office"
        email="admin@lewisandtrovas.com"
        phone="+61 2 9191 9268"
        address="Level 6, 25 Bligh Street, Sydney CBD NSW 2000"
        mail="Level 31, 25 Bligh Street, Sydney CBD NSW 2000"
        lat={-33.8649}
        lng={151.2106}
      />
    </div>

    {data.sydneyOfficePhoto &&
      <div className="max-1000 ma mt60 m-mt40 gutter-1000">
        <div className="ratio-16-10 pos-rel">
          <GatsbyImage image={data.sydneyOfficePhoto.childImageSharp.gatsbyImageData} alt="Sydney Office" className="bg-image" />
        </div>
      </div>
    }

    <div className="flex m-wrap m-direction-reverse max-1000 ma mt60 m-mt40 bt1-dark m-b0 pt40 mp0 mb40">
      <div className="w-70 m-100 pr20 mp0 m-mt20 m-bt1">
        <FormWrapper title="Fill in the form below and we will be in touch as soon as possible" mobileTitle="Alternatively, fill in the form below and we will be in touch as soon as possible" />
      </div>
      <div className="w-30 m-100 bl1">
        <p className="m0 m-show p20 bb1 h3">You can reach us here</p>
        <ContactInformation email="admin@lewisandtrovas.com" />
      </div>
    </div>

    <TextBanner button="Get Started" buttonWhite="true" link="https://lewisandtrovas.settify.com.au/landing?referral=homepage" background="#A69EA9" title="Alternatively, get started with our team today" text={data.datoCmsContactPage.alternativelyGetStartedWithOurTeamToday} />

  </Layout>)
}

export default ContactPage

export const query = graphql`
query{
  datoCmsContactPage {
    alternativelyGetStartedWithOurTeamToday
    metaDescription
    metaTitle
  }
  sydneyOfficePhoto: file(relativePath: { eq: "sydney-office.jpg" }) {
    childImageSharp {
      gatsbyImageData
    }
  }
}
`
